import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout-only: gives the collection editor a "Collections" crumb that links back to the list. */
export const Route = createFileRoute('/_authed/_active/s/$storeId/collections')({
  staticData: { crumb: 'common:nav.collections' },
  component: Outlet,
});
